var map = {
	"./es/announcements/list.json": [
		431,
		3
	],
	"./es/classes-book/edit.json": [
		432,
		4
	],
	"./es/classes-book/list.json": [
		433,
		5
	],
	"./es/common.json": [
		434,
		6
	],
	"./es/courses/details.json": [
		435,
		7
	],
	"./es/courses/list.json": [
		436,
		8
	],
	"./es/grade-replacement-petitions/list.json": [
		437,
		9
	],
	"./es/layouts.authorized.json": [
		438,
		10
	],
	"./es/learning-result/associate.json": [
		439,
		11
	],
	"./es/learning-result/list.json": [
		440,
		12
	],
	"./es/student-file/academic-history.json": [
		441,
		13
	],
	"./es/student-file/educational-background.json": [
		442,
		14
	],
	"./es/student-file/list.json": [
		443,
		15
	],
	"./es/student-file/personal-information.json": [
		444,
		16
	],
	"./es/student-file/petition.json": [
		445,
		17
	],
	"./es/student-file/tabs.json": [
		446,
		18
	],
	"./es/study-plan-enrollment-status.json": [
		447,
		19
	],
	"./es/teacher-attendance/list.json": [
		448,
		20
	],
	"./es/teacher-schedule/list.json": [
		449,
		21
	],
	"./es/terms.json": [
		450,
		22
	],
	"./es/translation.json": [
		451,
		23
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 424;
module.exports = webpackAsyncContext;